var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FilesField',{attrs:{"category":_vm.filesGroup,"access-to-add":_vm.isMobile,"content-type":"image"},on:{"remove":_vm.onRemoveFile,"add":_vm.onFileAddToUpload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }